/**
 * package: com.inq.flash.client.data
 * class: ChatCommunicationQueueMessage
 * @extends com.inq.flash.client.data.ChatCommunicationMessage 
 * @constructor
 */
com.inq.flash.client.data.ChatCommunicationQueueMessage = function(chat,text,alias) {
	com.inq.flash.client.data.ChatCommunicationMessage.call(this,chat,text);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT,"1");
	if(alias != null) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS,alias);
};
$hxClasses['com.inq.flash.client.data.ChatCommunicationQueueMessage'] = com.inq.flash.client.data.ChatCommunicationQueueMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatCommunicationQueueMessage.__name__ = ["com","inq","flash","client","data","ChatCommunicationQueueMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatCommunicationQueueMessage.__super__ = com.inq.flash.client.data.ChatCommunicationMessage;
for(var k in com.inq.flash.client.data.ChatCommunicationMessage.prototype ) com.inq.flash.client.data.ChatCommunicationQueueMessage.prototype[k] = com.inq.flash.client.data.ChatCommunicationMessage.prototype[k];
/** @type {com.inq.flash.client.data.ChatCommunicationQueueMessage} */
com.inq.flash.client.data.ChatCommunicationQueueMessage.prototype.__class__ = com.inq.flash.client.data.ChatCommunicationQueueMessage;
